import React from 'react';
import { useApiAutocomplete } from '../../hooks/useApiAutocomplete';
import Autocomplete from '../common/Inputs/Autocomplete';
import { useTrans } from '../../services/i18n';

const getOptionLabel = (option) => (option ? option.value : '');

export const OfficialCertificationsAutocomplete = (props) => {
  const { trans } = useTrans();
  const { onChange, value, multi, labelKey = 'value', label, ...rest } = props;
  const { options, loading, handleValueChange, filterOptions, handleInputChange } = useApiAutocomplete({
    labelKey,
    onChange: React.useCallback((val) => onChange && onChange(val), [onChange]),
    getOptionList: (params) => [
      { id: 'WOSB/WBE', value: trans('official-certification-wosb') },
      { id: 'EDWOSB', value: trans('official-certification-edwosb') },
      { id: 'VOSB/VBE', value: trans('official-certification-vosb') },
      { id: 'SDVOSB', value: trans('official-certification-sdvosb') },
      { id: 'a/MBE', value: trans('official-certification-mbe') },
    ],
  });

  const validateValueArray = () => {
    if (Array.isArray(value)) {
      return value;
    } else {
      return [];
    }
  };

  return (
    <Autocomplete
      name="grant-programs"
      options={options}
      label={label}
      labelKey={labelKey}
      loading={loading}
      value={validateValueArray()}
      filterOptions={filterOptions}
      onChange={handleValueChange}
      multiple={multi}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      freeSolo
      getOptionLabel={getOptionLabel}
      onInputChange={handleInputChange}
      {...rest}
    />
  );
};
